/* Installation enquiries go exclusively to the site's AgenticWeb inbox. */
(() => {
  function connect(form) {
    if (form.dataset.connected) return;
    form.dataset.connected = 'true';
    const messages = JSON.parse(form.querySelector('[data-request-messages]').textContent);
    const button = form.querySelector('[data-request-submit]');
    const fields = form.querySelector('[data-request-fields]');
    const status = form.querySelector('[data-request-status]');
    const error = form.querySelector('[data-request-error]');
    let pending = false;
    let completed = false;
    let requestId = null;
    let signature = null;
    button.disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || completed || !form.reportValidity()) return;
      const data = new FormData(form);
      const value = name => String(data.get(`contact[${name}]`) || '').trim();
      const configuration = {
        'Tip solicitare': value('Tip solicitare'),
        'Cod oferta': value('Cod oferta'),
        'Produs': value('Produs'),
        'Identificator produs': value('Identificator produs'),
        'Localitate': value('Localitate si judet'),
        'Judet montaj': value('Judet montaj'),
        'Pagina sistemului': form.dataset.productUrl
      };
      const payload = {
        key: form.dataset.siteKey,
        source: 'contact',
        name: value('name'), email: value('email'), phone: value('phone'),
        message: `${value('body')}\n\n${Object.entries(configuration).map(([key, val]) => `${key}: ${val}`).join('\n')}`,
        meta: { formId: 'sisteme-cu-montaj', ...configuration }
      };
      const nextSignature = JSON.stringify(payload);
      if (signature !== nextSignature) {
        requestId = `pv-installation-${crypto.randomUUID()}`;
        signature = nextSignature;
      }
      payload.externalId = requestId;
      pending = true;
      fields.disabled = true;
      button.textContent = messages.sending;
      form.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch('https://os.agenticweb.ro/api/embed/v1/lead', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          credentials: 'omit', signal: controller.signal, body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.ok !== true || !result.leadId) {
          const failure = new Error('request_failed');
          failure.rateLimited = response.status === 429;
          throw failure;
        }
        completed = true;
        fields.hidden = true;
        status.textContent = messages.request_success;
        status.hidden = false;
        status.focus();
      } catch (failure) {
        error.textContent = failure.rateLimited
          ? messages.request_rate_limit
          : messages.request_failure;
        error.hidden = false;
        error.focus();
      } finally {
        window.clearTimeout(timeout);
        pending = false;
        fields.disabled = completed;
        button.textContent = messages.request_submit;
        form.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-pv-request]').forEach(connect);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pv-request]').forEach(connect));
})();
